import { CdDivider } from '../../atoms/CdDivider';
import { CdTag } from '../../atoms/CdTag';
import { cx } from '../../utils';
import styles from './CdAppliedFilterTags.module.scss';

export interface AppliedFilter {
  id: string;
  label: string;
}

export interface CdAppliedFilterTagsProps {
  filters: AppliedFilter[];
  onRemove: (id: string) => void;
  onClearAll: () => void;
  /** Called when the "+N" overflow chip is pressed (opens the filter panel). */
  onShowAll?: () => void;
  maxVisible?: number;
  clearLabel?: string;
  className?: string;
}

/** "Clear filters | Tag × Tag × … +5" row under the index search bar. */
export const CdAppliedFilterTags = ({
  filters,
  onRemove,
  onClearAll,
  onShowAll,
  maxVisible = 5,
  clearLabel = 'Clear filters',
  className,
}: CdAppliedFilterTagsProps) => {
  if (filters.length === 0) return null;
  const visible = filters.slice(0, maxVisible);
  const hidden = filters.length - visible.length;

  return (
    <div className={cx(styles.root, className)}>
      <button type="button" className={styles.clear} onClick={onClearAll}>
        {clearLabel}
      </button>
      <CdDivider orientation="vertical" />
      <ul className={styles.list} aria-label="Applied filters">
        {visible.map((f) => (
          <li key={f.id}>
            <CdTag label={f.label} onDismiss={() => onRemove(f.id)} />
          </li>
        ))}
        {hidden > 0 && (
          <li>
            <button
              type="button"
              className={styles.more}
              onClick={onShowAll}
              aria-label={`Show ${hidden} more filters`}
            >
              +{hidden}
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};
